import { ViewModel,View, ObservableArray } from "binder"
import  { MacAddressManipulationView } from "./macAddressManipulation-view"
import { WindowViewModel } from "src/common/userMainWindow/windowContainer/windowContainer-viewModel";
import { ServerConnection } from "src/server/serverConnection";
import { stringIsNullOrEmpty } from "src/common/utilities";

export class MacAddressManipulationViewModel extends WindowViewModel{
    public getTitle(): string {
        return 'تنظیمات MacAddress';
    }
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.items = ObservableArray.create<Item>();

        this.refresh();
    }
    GetDefaultView(): View <ViewModel> {
        return new MacAddressManipulationView();
    }
    public getTypeId(): string {
        return "VM-3342E3FD-AEFF-423D-AD95-01C2946140D6"
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set items(v: ObservableArray<Item>) { this._items = v; } public get items(): ObservableArray<Item> { return this._items;} private _items: ObservableArray<Item>;
    
    async refresh(){
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/AuthenticationServices/GetAllUsersWithMacAddresses',{});
            this.items.update(...result.MacAddresses.map((x,i)=>{
                let r = new Item(this);
                r.index = i+1;
                r.id = x.UserId;
                r.userName = x.Username;
                r.personnelName = x.PersonnelFullName;
                r.macAddresses.update(...x.MacAddresses.map(q=>{
                    let r2 = new singleMac(r);
                    r2.mac = q;
                    return r2;
                }));
                return r;
            }));
        } catch (ex) {
            console.log(ex);
        } finally {
            this.isLoading = false;
        }
    }
    async invalidate(item:Item){
        let done = false;
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/AuthenticationServices/InvalidateMacAddressFilterForUser',{
                UserId : item.id
            });
            if(result.IsSuccessful){
                this.messageBoxConfirmSuccess('عملیات با موفیت انحام شد','باز شدن دسترسی');
                done = true;
            }else{
                this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
        if(done === true){
            this.refresh();
        }
    }
    
    async save(item:Item){
        let done = false;
        try {
            this.isLoading = true;
            let result = await ServerConnection.callServer('/Complex/AuthenticationServices/UpdateMacAddressFilter',{
                UserId : item.id,
                MacAddresses : item.macAddresses.map(x=>x.mac)
            });
            if(result.IsSuccessful){
                this.messageBoxConfirmSuccess('عملیات با موفیت انحام شد','اعمال تنظیمات');
                done = true;
            }else{
                this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
            }
        } catch (ex) {
            console.log(ex);
            this.messageBoxConfirmWarning('خطا در انجام عملیات','خطا');
        } finally {
            this.isLoading = false;
        }
        if(done === true){
            this.refresh();
        }
    }
}

export class Item extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:MacAddressManipulationViewModel) {
        super(parent);
        this._typedParent = parent;
        this.macAddresses = ObservableArray.create<singleMac>();
        this.newMac = '';
    }

    private _typedParent : MacAddressManipulationViewModel;
    public set index(v: number) { this._index = v; } public get index(): number { return this._index;} private _index: number;
    public set id(v: string) { this._id = v; } public get id(): string { return this._id;} private _id: string;
    public set userName(v: string) { this._userName = v; } public get userName(): string { return this._userName;} private _userName: string;
    public set personnelName(v: string) { this._personnelName = v; } public get personnelName(): string { return this._personnelName;} private _personnelName: string;
    public set macAddresses(v: ObservableArray<singleMac>) { this._macAddresses = v; } public get macAddresses(): ObservableArray<singleMac> { return this._macAddresses;} private _macAddresses: ObservableArray<singleMac>;
    public set newMac(v: string) { this._newMac = v; } public get newMac(): string { return this._newMac;} private _newMac: string;
    
    invalidate(){
        this._typedParent.invalidate(this);    
    }

    add(){
        if(stringIsNullOrEmpty(this.newMac)==false){
            let r = new singleMac(this);
            r.mac = this.newMac.trim().replaceAll("-","");
            this.macAddresses.push(r);
            this.newMac= '';
        }
    }

    confirm(){
        this._typedParent.save(this);
    }

    removeMac(mac:singleMac){
        this.macAddresses.remove(mac);
    }
}

export class singleMac extends ViewModel{
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}
    constructor(parent:Item) {
        super(parent);
        this._typedParent = parent;
    }
    private _typedParent : Item;
    public set mac(v: string) { this._mac = v; } public get mac(): string { return this._mac;} private _mac: string;

    remove(){
        this._typedParent.removeMac(this);
    }
}